/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthCenterDto } from '../../models/growth-center-dto';

export interface GrowthCenterControllerFindAll$Params {
}

export function growthCenterControllerFindAll(http: HttpClient, rootUrl: string, params?: GrowthCenterControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GrowthCenterDto>>> {
  const rb = new RequestBuilder(rootUrl, growthCenterControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GrowthCenterDto>>;
    })
  );
}

growthCenterControllerFindAll.PATH = '/api/growth-center';
